module.exports = __webpack_public_path__ + "static/img/panel_enterprise_ski.9005452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rescuelist/panel_enterprise_ski.png
// module id = 6FRW
// module chunks = 1